import { z } from 'zod'

export const CustomRoleFormEntitySchema = z.object({
  name: z.string(),
  assignUserIds: z.array(z.number()),
  policyIds: z.array(z.number()),
})

export type CustomRoleFormEntity = z.infer<typeof CustomRoleFormEntitySchema>
